import React from 'react';
import { Flex, Typography } from 'antd';
import miruLogo from '../assets/miru-logo.png';

const { Text } = Typography;

const FOOTER_LINKS = {
  Product: [
    { label: 'About ABHA', href: 'https://abdm.gov.in/abdm' },
    { label: 'How to Create', href: '#how-to' },
    { label: 'Benefits', href: '#benefits' },
    { label: 'FAQ', href: '#faq' },
  ],
  Support: [
    { label: 'Help Center', href: 'https://miru.co.in/contact' },
    { label: 'Contact Us', href: 'https://miru.co.in/contact' },
    { label: 'Privacy Policy', href: '/' },
    { label: 'Terms of Service', href: '/' },
  ],
  'Gov. Links': [
    { label: 'ABDM Portal', href: 'https://abdm.gov.in/abdm' },
    { label: 'NHA', href: 'http://nha.gov.in/' },
    { label: 'Ayushman Bharat', href: 'https://beneficiary.nha.gov.in/' },
    { label: 'DigiLocker', href: 'https://www.digilocker.gov.in/' },
  ],
};

const Footer = () => {
  return (
    <footer
      style={{
        background: 'linear-gradient(135deg, #0f0028 0%, #1e0050 100%)',
        padding: '60px 0 28px',
      }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img
                src={miruLogo}
                alt="MiRu Logo"
                style={{ height: 60, objectFit: 'contain', width: 'auto', maxWidth: '100%' }}
              />
            </div>
            <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>
              Powered by Ayushman Bharat Digital Mission. Your digital health identity, secured for life.
            </p>
          </div>

          {/* Link columns */}
          {Object.entries(FOOTER_LINKS).map(([section, links]) => (
            <div key={section}>
              <p
                className="text-xs font-bold tracking-widest mb-5"
                style={{ color: '#c4a0ff', letterSpacing: '0.1em' }}
              >
                {section.toUpperCase()}
              </p>
              <ul className="space-y-3 list-none p-0 m-0">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target={link.href.startsWith('http') ? '_blank' : '_self'}
                      rel={link.href.startsWith('http') ? 'noopener noreferrer' : ''}
                      onClick={(e) => {
                        if (!link.href.startsWith('http') && link.href === '/') {
                          e.preventDefault();
                        }
                      }}
                      className="text-sm transition-colors duration-200"
                      style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}
                      onMouseEnter={(e) => (e.target.style.color = '#c4a0ff')}
                      onMouseLeave={(e) => (e.target.style.color = 'rgba(255,255,255,0.55)')}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div
          style={{
            borderTop: '1px solid rgba(255,255,255,0.1)',
            paddingTop: 24,
          }}
        >
          <Flex justify="space-between" align="center" wrap="wrap" gap={12}>
            <Text style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13 }}>
              © 2026 Miru Digital Services. All rights reserved.
            </Text>
            <Text style={{ color: 'rgba(255,255,255,0.4)', fontSize: 13 }}>
              🇮🇳 Made in India · Powered by ABDM
            </Text>
          </Flex>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
